import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusTripsheetDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [TripsheetStatusOptions, setTripsheetStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { tripsheetStatus, setTripsheetStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
    type: "tripsheetStatus"
  } as BaseInputFilter);

  useEffect(() => {
  if (parameters?.data) {
    setTripsheetStatus(parameters.data); 

    setTripsheetStatusOptions(
      parameters.data.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }
}, [parameters]);



  return (
    <Dropdown
      value={options.value}
      options={TripsheetStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status"
      showClear
    />
  );
};
export default StatusTripsheetDropdown;
